export class ClaimSearchRequest {
    ClientId: string;
    ServiceEventIds: string[] = [];
    IncludePHI: boolean;
}
